import IntegrationConnectPage from './IntegrationConnectPage';

const SlackConnectPage = () => <IntegrationConnectPage defaultProvider="slack" />;

export default SlackConnectPage;
